import { formatQtyUom, sameUom, toProducedQty } from '@/lib/uom';

/** "= 18 in per unit" under a BOM quantity entered in another unit. */
export function BomQtyPreview({
  quantity,
  uom,
  producedUom,
}: {
  quantity: string;
  uom: string;
  producedUom: string | null | undefined;
}) {
  if (!producedUom) return null;
  const qty = Number(quantity);
  if (!uom || sameUom(uom, producedUom) || !Number.isFinite(qty) || qty <= 0) {
    return (
      <p className="text-xs text-muted-foreground">
        Quantity is in {producedUom}, the component&apos;s UoM Produced.
      </p>
    );
  }
  const produced = toProducedQty(qty, uom, producedUom);
  return (
    <p className="text-xs text-muted-foreground tabular-nums">
      {formatQtyUom(qty, uom)} ={' '}
      <span className="font-medium text-foreground">{formatQtyUom(produced.quantity, produced.uom)}</span>{' '}
      per unit. Saved in {producedUom}, the component&apos;s UoM Produced.
    </p>
  );
}
